<template>
  <div>
    <v-dialog v-model="show" max-width="700" persistent>

      <v-card>
        <v-card-title class="justify-center">
          <v-icon left color="blue">mdi-file-upload-outline</v-icon>
          Enviando atividade
        </v-card-title>

        <v-divider />

        <v-card-text class="mt-5">

          <v-row>
            <v-col cols="12">
              <v-alert :value="alert" dense text type="warning">
                Você enviará a atividade para: <strong>{{ getAnosText() }}</strong>
              </v-alert>

              <v-alert :value="success" dense text type="success">
                Atividade enviada com <strong>sucesso!</strong>
              </v-alert>

              <v-alert :value="error" dense outlined type="error">
                <strong>Erro</strong> ao enviar a atividade!
              </v-alert>
            </v-col>
          </v-row>

          <v-row class="mt-1">
            <v-text-field v-model="nomeAtividade" label="Nome da atividade" prepend-icon="mdi-file" outlined
              dense></v-text-field>
          </v-row>
          <v-row>
            <v-file-input v-model="arquivoSelecionado" accept="application/pdf" label="Selecione a atividade" outlined
              dense></v-file-input>
          </v-row>
          <v-row>
            <v-select v-model="escolasSelecionadas" :items="escolasParaSelecao" item-text="nome"
              prepend-icon="apartment" return-object chips outlined dense label="Escolas" multiple>
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.nome }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption">
                  (+{{ escolasSelecionadas.length - 1 }} outros)
                </span>
              </template>

              <template v-slot:prepend-item>
                <v-list-item ripple @mousedown.prevent @click="toggle">
                  <v-list-item-action>
                    <v-icon :color="escolasSelecionadas.length > 0 ? 'blue' : 'blue'">
                      {{ icon() }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Selecionar Todos
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>

            </v-select>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="red" dark @click="fechar" :loading="enviandoAtividade">Fechar</v-btn>
          <v-btn :disabled="arquivoSelecionado == null || nomeAtividade.length < 3 || escolasSelecionadas.length < 1"
            color="blue" class="white--text" @click="enviar" :loading="enviandoAtividade">Enviar</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import AtividadeComplementarService from "@/service/AtividadeComplementarService";
import { mapGetters } from "vuex";

export default {
  name: "EnviarAtividade",
  props: {
    show: Boolean,
    anosParaEnviar: Array,
    fechar: Function
  },
  data() {
    return {
      arquivoSelecionado: null,
      nomeAtividade: "",
      enviandoAtividade: false,
      escolasParaSelecao: [],
      escolasSelecionadas: [],

      success: false,
      alert: true,
      error: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'Login/user'
    })
  },
  methods: {
    showBtn(item) {
      return item.includes(this.user ? this.user.perfil : '');
    },
    icon() {
      if (this.escolasSelecionadas.length == this.escolasParaSelecao.length) return 'mdi-close-box'
      if (this.escolasSelecionadas.length > 0) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    toggle() {
      this.$nextTick(() => {
        if (this.escolasSelecionadas.length == this.escolasParaSelecao.length) {
          this.escolasSelecionadas = []
        } else {
          this.escolasSelecionadas = this.escolasParaSelecao.slice()
        }
      })
    },
    getAnosText() {
      let anos = '';
      for (let i = 0; i < this.anosParaEnviar.length; i++) {
        anos = anos + ' ' + this.anosParaEnviar[i].ano + '° ano de ' + this.anosParaEnviar[i].disciplina
        if (i < this.anosParaEnviar.length - 1) anos += ','
      }
      if (anos.length > 40)
        return anos.substring(0, 40) + '...';
      else
        return anos;
    },

    enviar() {

      const formData = new FormData();
      formData.append("atividade", this.arquivoSelecionado);
      let anos = this.getAnosId();
      let escolas = this.getEscolasId();

      this.enviandoAtividade = true;

      AtividadeComplementarService.enviar(formData, this.nomeAtividade, anos, escolas)
        .then(() => {
          this.alert = false;
          this.error = false;
          this.success = true;
          this.arquivoSelecionado = null;
          this.nomeAtividade = "";
        })
        .catch(() => {
          this.error = true;
          this.alert = false;
          this.success = true;
        })
        .finally(() => {
          this.enviandoAtividade = false;
        });
    },

    getAnosId() {
      let anos = '';
      for (let i = 0; i < this.anosParaEnviar.length; i++) {
        anos = anos + this.anosParaEnviar[i].id
        if (i < this.anosParaEnviar.length - 1) anos += ','
      }
      return anos;
    },
    getEscolasId() {
      let escolasId = '';
      for (let i = 0; i < this.escolasSelecionadas.length; i++) {
        escolasId = escolasId + this.escolasSelecionadas[i].id
        if (i < this.escolasSelecionadas.length - 1) escolasId += ','
      }
      return escolasId;
    },
    getEscolas() {
      AtividadeComplementarService.getEscolasParaSelecao()
        .then(({ data }) => {
          this.escolasParaSelecao = data;
        });
    }
  },
  watch: {
    show() {
      console.log('Entrou...')
      if (this.show) {
        this.escolasSelecionadas = [];
        this.getEscolas();
        this.alert = true;
        this.success = false;
        this.error = false;
      }
    },
  },
}
</script>